import { render } from "./CalendarMultiselect.vue?vue&type=template&id=bb078ce4"
import script from "./CalendarMultiselect.vue?vue&type=script&lang=js"
export * from "./CalendarMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__